export default __webpack_public_path__ + "static/media/calendar-screen.b830b296.png";